module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Steven F. Havill\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Steven F. Havill lives with his wife of fifty-three years, Kathleen, in New Mexico. He is the author of thirty-two novels, taught secondary schools for 25 years, and recently earned an AAS degree in gunsmithing.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7UEETn/tc-custom/9781615950843.jpg?1718183001147",
      "alt": "This image is the cover for the book Scavengers, Posadas County Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Scavengers, Posadas County Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The acclaimed New Mexico mystery series continues as a former deputy leads an investigation into a series of perplexing murders.")])]), _c('p', [_vm._v(" A man’s body is found in the unforgiving New Mexico desert, his face so smashed that identification is impossible. It’s the beginning of a brutal murder spree that will soon take Posadas County’s new undersheriff, Estelle Reyes-Guzman, into a case that has roots on both sides of the border. ")]), _c('p', [_vm._v(" With the help of retired Sheriff Bill Gastner—now a state livestock inspector—Reyes-Guzman attempts to identify the “Juan” Doe. Another body turns up in a shallow grave, revealing little about the killer, but more about the victims. And when a suspicious fire takes a third life, the terrible twist finally offers the break Estelle has been looking for, one that will lead her back into a harsh, merciless desert where death welcomes all. ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Poisoned Pen Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0